import * as React from "react";
import { Stack } from "@mui/material";
import { Header } from "../../components/atoms/Header";
import { colors } from "../../styles/constants";
import { ExpressFormHeader } from "./ExpressFormHeader";
import { UpdateExpressFormTemplateProc } from "@/templates/ExpressFormTemplate";
import { insideIframe } from "../../utils/Functions";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { Hr } from "@/components/atoms";
import { DeceasedFormHandle, ExpressDeceasedForm } from "./Deceased";
import { SPContext } from "@/store/SPProvider";
import { SingleAccountForm } from "./SingleAccountForm";
import MultiAccountForm from "./MultiAccount";

export type CIExpressAccount = {
  readonly navAfterAccount: () => void;
  readonly onSectionClick: (section: string) => void;
  readonly updateTemplate: UpdateExpressFormTemplateProc;
};

export const ExpressAccount: React.FunctionComponent<CIExpressAccount> = ({
  navAfterAccount,
  onSectionClick,
  updateTemplate,
}) => {
  useScrollToTop();

  const { state: sp } = React.useContext(SPContext);
  const deceasedFormRef = React.useRef<DeceasedFormHandle>(null);

  const newNaveAfterAccount = React.useCallback(() => {
    if (!deceasedFormRef.current?.hasErrors()) {
      navAfterAccount();
    }
  }, [deceasedFormRef]);

  if (!sp.id) return null;
  return (
    <Stack rowGap={4}>
      {insideIframe ? null : <ExpressFormHeader serviceProvider={sp} />}

      <Header level={2} color={colors.accentTeal}>
        Account Details for the person who died
      </Header>

      <ExpressDeceasedForm ref={deceasedFormRef} />
      <Hr />
      {!sp.expressMultiAccount && (
        <SingleAccountForm
          navAfterAccount={newNaveAfterAccount}
          onSectionClick={onSectionClick}
          updateTemplate={updateTemplate}
        />
      )}
      {!!sp.expressMultiAccount && (
        <MultiAccountForm
          navAfterAccount={newNaveAfterAccount}
          onSectionClick={onSectionClick}
          updateTemplate={updateTemplate}
        />
      )}
    </Stack>
  );
};
